export const COPYRIGHT = "© 2021 Couchers.org Foundation";
